<template>
  <router-view></router-view>
</template>

<script>
  import '@/assets/sass/arrow.scss'

  window.a = process.env.NODE_ENV
  window.b = process.env.API_DOMAIN

  export default {
    mounted () {
      //
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?3f49acf8